export const EXTENSION_SYNC_EVENT = "AIRWRITE_SYNC_USER";

interface ExtensionSyncPayload {
  userId: string;
  authToken?: string;
  clearUsage?: boolean;
  refreshSettings?: boolean;
}

interface ExtensionSyncOptions {
  authToken?: string;
  clearUsage?: boolean;
  refreshSettings?: boolean;
}

/**
 * Broadcasts the latest authenticated user ID and auth token to the Chrome
 * extension so it can update chrome.storage.local without requiring manual input.
 */
export function syncExtensionUserId(
  userId: string | null | undefined,
  options: ExtensionSyncOptions = {},
) {
  if (typeof window === "undefined") {
    return;
  }

  const payload: ExtensionSyncPayload = {
    userId: userId ?? "",
    authToken: options.authToken,
    clearUsage: options.clearUsage ?? !userId,
    refreshSettings: options.refreshSettings ?? false,
  };

  try {
    window.postMessage(
      {
        source: "airwrite-web",
        type: EXTENSION_SYNC_EVENT,
        payload,
      },
      window.location.origin,
    );
  } catch (error) {
    if (process.env.NODE_ENV !== "production") {
      console.warn("Failed to sync extension user", error);
    }
  }
}
